import React from 'react';
import {reduxForm} from 'redux-form';
import FormField from '../form/form-field';
import FileField from '../form/file-field';

import BaseForm from '../form/base-form';
import {validateRequiredFields} from '../../utils/form';
import LocalizedStrings from '../../localization/strings';

import Button from '../button';
import Alert from '../alert';

const fields = ['file'];

function validate(values) {
    let errors = {
        _error: null
    };
    errors = validateRequiredFields(values, ['file'], errors);
    return errors;
}

class StageResultsForm extends BaseForm {

    render() {
        const {submitting, error, handleSubmit, fields: {
                file
            }} = this.props;
        return (
            <div>
                <form onSubmit={handleSubmit(this.submit.bind(this))}>
                    {error && <Alert type="error">{error}</Alert>}

                    <div className="actions-row">

                        <FormField label={LocalizedStrings.file} name="file" field={file}>
                            <FileField {...file}></FileField>
                        </FormField>

                        <Button loading={submitting} submit={true} disabled={submitting} type="primary">
                            {LocalizedStrings.submit}
                        </Button>

                    </div>

                </form>
            </div>
        )
    }
}

export default reduxForm({
    form: 'stage-results-form',
    fields,
    validate,
    destroyOnUnmount: true
}, state => ({initialValues: state.stage.stage.item}))(StageResultsForm);



// WEBPACK FOOTER //
// ./src/js/components/stage/stage-results-form.js